const routes = [
    {
        path: '/',
        component: () => import('src/apps/cloud/versions/v1/layouts/MainLayout.vue'),
        children: [
            { path: '', component: () => import('src/apps/cloud/versions/v1/pages/dashboard/DashboardPage.vue') },
            { path: 'farms', component: () => import('src/apps/cloud/versions/v1/pages/dashboard/DashboardPage.vue') },
            { path: 'farms/:id', component: () => import('src/apps/cloud/versions/v1/pages/farms/FarmPage.vue') },
            { path: 'users', component: () => import('src/apps/cloud/versions/v1/pages/users/UsersPage.vue') },
            { path: 'users/:id', component: () => import('src/apps/cloud/versions/v1/pages/users/UserPage.vue') },
            { path: 'profile', component: () => import('src/apps/cloud/versions/v1/pages/ProfilePage.vue') },
            { path: 'settings', component: () => import('src/apps/cloud/versions/v1/pages/SettingsPage.vue') },
            { path: 'admin/settings', component: () => import('src/apps/cloud/versions/v1/pages/admin/SettingsPage.vue') },
            { path: 'admin/clusters', component: () => import('src/apps/cloud/versions/v1/pages/admin/ClustersPage.vue') },
            { path: 'registration', component: () => import('src/apps/cloud/versions/v1/pages/dashboard/DashboardPage.vue') },
            { path: 'confirm', component: () => import('src/apps/cloud/versions/v1/pages/dashboard/DashboardPage.vue') },
            { path: 'forgot-password', component: () => import('src/apps/cloud/versions/v1/pages/dashboard/DashboardPage.vue') },
            { path: 'reset-password', component: () => import('src/apps/cloud/versions/v1/pages/dashboard/DashboardPage.vue') },
        ],
    },
    // Always leave this as last one,
    // but you can also remove it
    {
        path: '/:catchAll(.*)*',
        component: () => import('pages/ErrorNotFound.vue'),
    },
];
export default routes;
